import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TeacherModel } from 'src/app/models/backend.model';
import { BackendService } from 'src/app/services/backend.service';
import { TitleService } from 'src/app/services/title.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-teacher',
  templateUrl: './teacher.component.html',
})
export class TeacherComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  teacher: TeacherModel;
  teacherName: string;
  isLoading = false;
  backendUrl = environment.backendUrl;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly backendService: BackendService,
    private readonly titleService: TitleService
  ) {
    this.isLoading = true;
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.teacherName = params.get('name') || '';
      this.backendService.getTeacher(this.teacherName).then(teacher => {
        this.teacher = teacher.result;
        this.titleService.setTitle(teacher.result.displayName);
        for (const course of this.teacher.courses) {
          course.teacher = {
            displayName: this.teacher.displayName,
            profilePic: this.teacher.profilePic,
          };
        }

        this.isLoading = false;
      }).catch(e => {
        this.isLoading = false;
      });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
